
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";
import { InterfaithResponse, SavedDialogueContent } from "../types";
import { Json } from "@/integrations/supabase/types";

export const saveInterfaithResponse = async (
  userId: string,
  selectedFaith: string | null,
  question: string,
  response: InterfaithResponse | null
) => {
  if (!response || !userId) {
    toast({
      title: "Cannot save response",
      description: userId ? "No response to save" : "Please sign in to save responses",
      variant: "destructive"
    });
    return false;
  }

  try {
    console.log("Saving interfaith response...");
    
    // Create a JSON-compatible version of the response by first converting to a string and back to an object
    // This ensures the response is fully serializable as Json
    const jsonString = JSON.stringify({
      faithGroup: selectedFaith,
      question,
      response,
      createdAt: new Date().toISOString()
    });
    
    // Parse back to get a plain object that's compatible with Json type
    const contentObj = JSON.parse(jsonString) as Json;
    
    console.log("Content prepared for storage:", contentObj);
    
    const { error: insertError, data: savedData } = await supabase
      .from('saved_responses')
      .insert({
        tool_type: 'interfaith_dialogue',
        title: `Interfaith Dialogue: ${selectedFaith} - ${question.substring(0, 50)}${question.length > 50 ? '...' : ''}`,
        content: contentObj,
        user_id: userId
      })
      .select();

    if (insertError) {
      console.error("Error inserting saved response:", insertError);
      throw insertError;
    }

    console.log("Response saved successfully:", savedData);

    toast({
      title: "Response Saved",
      description: "Your response has been saved to your dashboard."
    });
    
    return true;
  } catch (error) {
    console.error('Error saving response:', error);
    toast({
      title: "Error",
      description: "Failed to save response. Please try again later.",
      variant: "destructive"
    });
    return false;
  }
};
